import { render, staticRenderFns } from "./ShopCatalogue.vue?vue&type=template&id=ccdda0e0&scoped=true"
import script from "./ShopCatalogue.vue?vue&type=script&lang=js"
export * from "./ShopCatalogue.vue?vue&type=script&lang=js"
import style0 from "./ShopCatalogue.vue?vue&type=style&index=0&id=ccdda0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdda0e0",
  null
  
)

export default component.exports